import script from "./AppModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppModal.vue?vue&type=script&setup=true&lang=ts"

import "./AppModal.vue?vue&type=style&index=0&id=3a0eebb8&lang=scss&scoped=true"
import "./AppModal.vue?vue&type=style&index=1&id=3a0eebb8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a0eebb8"]])

export default __exports__